import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import { Cascader, Card, Popover } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import "@/assets/fonts/font.css"; // global css
import "@/styles/index.scss"; // global css
import "@/styles/common.scss"; // common css
import axios from "axios";
import App from "./App";
import router from "./router";
import store from "./store";
import "amfe-flexible";
Vue.prototype.$axios = axios;
Vue.component(Cascader.name, Cascader);
Vue.component(Card.name, Card);
Vue.component(Popover.name, Popover);

import { Area } from "vant-green";
import { Popup } from "vant-green";
import "vant-green/lib/index.css";
Vue.use(Area);
Vue.use(Popup);

Vue.config.productionTip = false;

import VideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

Vue.use(VideoPlayer);

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js